import { useTranslation } from '@packlink/translation-provider';
import { Spinner, Typography } from '@shipengine/giger';
import { SubscriptionPanel } from '@common/components/SubscriptionPanel/SubscriptionPanel';
import { useSubscriptionPlans } from '@Subscriptions/hooks/useClientSubscriptions';
import { getHeaderStyles } from '../OnboardingPageStyles';
import { getSpinnerStyles, getTitleStyles } from './OnboardingSelectPlanStyles';
import { APP_ROUTE } from '@router/routes';
import { SelectPlan } from '@common/components/SelectPlan/SelectPlan';
import { useFeatureFlags } from '@common/hooks/useFeatureFlags';

export const OnboardingSelectPlan = (): JSX.Element => {
    const { t } = useTranslation();
    const { subscriptionPlans, isLoading } = useSubscriptionPlans();
    const { newOnboarding } = useFeatureFlags();
    // If at some point we have multiple subscription plans, this will have to change
    const plusPlan = subscriptionPlans?.[0];
    const nextRoute = newOnboarding ? APP_ROUTE.ONBOARDING.PLATFORMS : APP_ROUTE.ONBOARDING.WELCOME;

    return isLoading ? (
        <Spinner css={getSpinnerStyles} />
    ) : (
        <>
            <Typography variant="heading3" component="h3" css={getHeaderStyles}>
                {t('onboarding.layout.title')}
            </Typography>

            <Typography variant="body1" component="p" css={[getHeaderStyles, getTitleStyles]}>
                {t('plans.selection.title')}
            </Typography>

            <SelectPlan nextPage={nextRoute} isOnboarding />

            {plusPlan && <SubscriptionPanel planDetails={plusPlan} nextPage={nextRoute} />}
        </>
    );
};
